import request from '@/utils/request';

export function getVouchs() {
    return request({
        url: '/position/mavin/search/form/vouchs',
        method: 'get'
    });
}

export function getBoards() {
    return request({
        url: '/position/mavin/search/form/boards',
        method: 'get'
    });
}

export function getAudits() {
    return request({
        url: '/position/mavin/search/form/audits',
        method: 'get'
    });
}